<!-- Authord.by.KWShin.2024.09.25. -->
<template>
  <div class="h-100">
    <v-chart ref="chart" :options="options" :init="init" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import liquidChartable from '../../../components/liquidChartable';

export default {
  mixins: [liquidChartable],
  props: {
    sstmId: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters('common/system', ['getSystemById']),
    dbType() {
      return this.getSystemById(this.sstmId).database.type;
    },
    title() {
      return this.$t('dv.title.db.space');
    },
  },
  watch: {
    value(data) {
      this.setData(data);
    },
  },
  data() {
    return {
      data: {
        value: '',
        type: 'percent',
      },
    };
  },
  methods: {
    setData(dataList) {
      if (this.dbType == 'HANA') {
        let sizeSum = 0;
        let usedSum = 0;
        dataList.forEach(data => {
          sizeSum += data.totalSize ? parseInt(data.totalSize) : 0;
          usedSum += data.usedSize ? parseInt(data.usedSize) : 0;
        });
        this.data.value = sizeSum == 0 ? 0 : Math.ceil((usedSum / sizeSum) * 100);
      } else {
        this.data.value = dataList[0]?.usedRate;
      }
    },
  },
};
</script>
